class ServerUtils {
    static isDev() {
        return process.env.MIX_APP_ENV === 'development';
    }

    static isLocal() {
        return process.env.MIX_APP_ENV === 'local';
    }

    static isAlpha() {
        return process.env.MIX_APP_ENV === 'alpha';
    }

    static isProduction() {
        return process.env.MIX_APP_ENV === 'production';
    }

    static isDevOrLocal() {
        return ServerUtils.isDev() || ServerUtils.isLocal();
    }
}


export default ServerUtils;
